/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const DiscountsSkeleton = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.skeletonWrapper}>
      <Skeleton count={1} className={classes.headerSk} />
      <div className={classes.firstRow}>
        <Skeleton count={1} width={400} className={classes.shortSk} />
        <Skeleton count={1} width={200} className={classes.shortSk} />
      </div>
      <div className={classes.cardsWrapper}>
        <Skeleton count={1} width={280} className={classes.cardSk} />
        <Skeleton count={1} width={280} className={classes.cardSk} />
        <Skeleton count={1} width={280} className={classes.cardSk} />
      </div>
    </div>
  );
};

export default DiscountsSkeleton;
